// One request read under the person's addresses (02-escalation-and-grants.md
// § the approver): a link to a request names only its id.

import { isRefusal, type Bus } from "../../platform/bus.ts";
import { Code, escalationSubject, SERVICE, type Record_ } from "../../wire/guard.ts";
import { addresses } from "./addressed.ts";

/**
 * getAddressed reads one escalation under the first of the person's addresses
 * that holds it: a link to a request names only its id, and a request
 * addressed elsewhere is not found under every address.
 */
export async function getAddressed(
  bus: Bus,
  principal: string,
  admin: boolean,
  id: string,
): Promise<Record_> {
  let last: unknown = new Error("guard: no address to read the request under");
  for (const approver of addresses(principal, admin)) {
    try {
      return await bus.call<Record_>(SERVICE, escalationSubject(approver, "get", id), undefined);
    } catch (e: unknown) {
      if (!isRefusal(e, Code.notFound)) {
        throw e;
      }
      last = e;
    }
  }
  throw last;
}
